import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getAlertById } from '../../services/AlertsService';
import { AlertDetails } from '../../types/Alerts';
import { FeaturesManagement } from '../../../featuresControl';

function useGetAlertById(id: string, fleetId: string): UseQueryResult<AlertDetails> {
  return useQuery(
    ['alert', id, fleetId],
    async (): Promise<AlertDetails> => getAlertById(id, fleetId),
    {
      retry: 1,
      retryDelay: 3000,
      refetchInterval: FeaturesManagement.productivity.refetchInterval,
      keepPreviousData: true,
      enabled: !!id,
    },
  );
}

export default useGetAlertById;
